




























import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Student } from '../../models/student/student';
import { GPageBase } from '../../mixins';
import draggable from 'vuedraggable';
import { GEnum } from '@/constants/enum.defination';
import { schoolClassChangeModule } from '@/store/modules/frames/school-class-change.module';
import { StudentsByClass } from '@/models/student/students-by-class';
import GStudentRecordItemCell from '@/views/GStudentRecord/GStudentRecordItemCell.vue';
import GStudentRecordValueCell from '@/views/GStudentRecord/GStudentRecordValueCell.vue';
import { studentModule } from '@/store/modules/entities/student.module';
import GSchoolClassBulkMoveModal from '@/views/GSchoolClassChange/GSchoolClassBulkMoveModal.vue';
import GSchoolClassChangeToolBar from '@/views/GSchoolClassChange/GSchoolClassChangeToolBar.vue';
import GSchoolClassChangeStudentTile from '@/views/GSchoolClassChange/GSchoolClassChangeStudentTile.vue';

@Component({
  name: 'GSchoolClassesDraggable',
  computed: {},
  components: {
    GSchoolClassChangeStudentTile,
    GSchoolClassChangeToolBar,
    GSchoolClassBulkMoveModal,
    GStudentRecordValueCell,
    GStudentRecordItemCell,
    draggable,
  },
  methods: {},
})
export default class GSchoolClassesDraggable extends Mixins(GPageBase) {
  currentPage: number = 1;
  pageSize: number = 20;
  options: any = { group: 'drag_list', handle: '.person-item' };
  tempSelectedStudent: Student = new Student();

  @Prop({ default: () => {} }) studentsBySchoolClass: StudentsByClass;

  mounted() {}

  get dragAreaTypeSchoolClass(): GEnum.DragAreaType {
    return GEnum.DragAreaType.TypeSchoolClass;
  }

  get isDragging(): boolean {
    return schoolClassChangeModule.isDragging;
  }

  get studentsBySchoolClasses(): StudentsByClass[] {
    return studentModule.studentsBySchoolClasses;
  }

  handlePagerChange(nextPage: number) {
    this.currentPage = nextPage;
  }

  handleAdd(e: any) {
    // 新しいクラスに移動時に選択色をセットする
    const updateStudent: Student = this.studentsBySchoolClass.students[e.newIndex];

    if (this.studentsBySchoolClass.schoolClass.schoolClassID !== updateStudent.schoolClass.schoolClassID) {
      updateStudent.dragState = GEnum.DragState.Changed;
    } else {
      // 元のいたクラスに戻ってきた場合に変更なし状態に戻す
      updateStudent.dragState = GEnum.DragState.Fixed;
    }
  }

  handleStart(e: any) {
    // 選択時に選択色をセットする
    this.tempSelectedStudent = this.studentsBySchoolClass.students[e.oldIndex];
    this.studentsBySchoolClass.students[e.oldIndex].dragState = GEnum.DragState.Selected;
    schoolClassChangeModule.setIsDragging(true);
  }

  handleDragEnd(e: any) {
    // 選択終了時に選択色からあるべき色に戻す
    const updateStudent: Student = this.studentsBySchoolClass.students[e.newIndex];

    if (updateStudent !== undefined && this.tempSelectedStudent.studentID === updateStudent.studentID) {
      // 同じクラス内での移動時
      if (this.studentsBySchoolClass.schoolClass.schoolClassID === updateStudent.schoolClass.schoolClassID) {
        // クラスが変わっていなかったら
        updateStudent.dragState = GEnum.DragState.Fixed;
      } else {
        // クラスがすでに変わっていたら
        updateStudent.dragState = GEnum.DragState.Changed;
      }
    }
    schoolClassChangeModule.setIsDragging(false);
  }
}
